import { render, staticRenderFns } from "./text-modal-for-agreement.vue?vue&type=template&id=442452f3&scoped=true&"
import script from "./text-modal-for-agreement.vue?vue&type=script&lang=js&"
export * from "./text-modal-for-agreement.vue?vue&type=script&lang=js&"
import style0 from "./text-modal-for-agreement.vue?vue&type=style&index=0&id=442452f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442452f3",
  null
  
)

export default component.exports